import React from 'react'
import PropTypes from 'prop-types'
import { ArticleIcon, PeopleIcon } from 'secondstep-components'
import ReportsDropdown from './ReportsDropdown'
import {
  SUPPORTING_LESSON_INSTRUCTORS_PATH,
  USER_MANAGEMENT_PATH,
} from './constants'
import {
  LeaderContainer,
  StyledAccessibleTextLink,
  SupportingInstructorsIconWrap,
} from './component.styles'
import NavigationHelper from 'layers/navigation/navigationHelper'

const K8ReportingLeaderTools = ({
  classesCount,
  entry,
  error,
  historicalReportingOnClick,
  historicalReports,
  isDownloadingHistoricalReportData,
  isDwbReportRoute,
  isFetchingDocumentUrl,
  isSchoolSummary,
  navigationEvent,
  onClickCurrentYear,
  selectedSite,
}) => {
  const { schoolCsvDownloadTooltip } = entry || {}

  const csvDropdownData = {
    classesCount,
    error,
    historicalReports,
    historicalReportingOnClick,
    isFetching: isFetchingDocumentUrl || isDownloadingHistoricalReportData,
    onClickCurrentYear,
    schoolCsvDownloadTooltip,
  }

  return (
    <LeaderContainer data-testid="LeaderContainer">
      {!isDwbReportRoute && (
        <ReportsDropdown
          {...csvDropdownData}
          isFetchingDocumentUrl={isFetchingDocumentUrl}
        />
      )}
      {isSchoolSummary && (
        <StyledAccessibleTextLink
          ariaLabel="manage-users-link"
          dataTestId="manage-users-link"
          onClick={() =>
            navigationEvent(
              `${USER_MANAGEMENT_PATH}/${selectedSite}`,
              NavigationHelper.types.OPEN,
            )
          }
        >
          <PeopleIcon /> Manage Users
        </StyledAccessibleTextLink>
      )}
      <StyledAccessibleTextLink
        ariaLabel="supporting-instructors-link"
        dataTestId="supporting-instructors-link"
        href={SUPPORTING_LESSON_INSTRUCTORS_PATH}
      >
        <SupportingInstructorsIconWrap>
          <ArticleIcon />
        </SupportingInstructorsIconWrap>{' '}
        Supporting Instructors
      </StyledAccessibleTextLink>
    </LeaderContainer>
  )
}

K8ReportingLeaderTools.propTypes = {
  classesCount: PropTypes.number,
  entry: PropTypes.object,
  error: PropTypes.object,
  historicalReportingOnClick: PropTypes.func,
  historicalReports: PropTypes.array,
  isDownloadingHistoricalReportData: PropTypes.bool,
  isDwbReportRoute: PropTypes.bool,
  isFetchingDocumentUrl: PropTypes.bool,
  isSchoolSummary: PropTypes.bool,
  navigationEvent: PropTypes.func,
  onClickCurrentYear: PropTypes.func,
  selectedSite: PropTypes.number,
}

export default K8ReportingLeaderTools
